import { useFragment } from '@apollo/client/react';

import { createRequiredContext } from 'src/context/createRequiredContext';
import { DepositorFields } from 'src/graphql/actions/escrow/escrowDepositor.fragment';
import { AgreementFormEnum, type IDepositor } from 'src/graphql/schema';

const [useDepositorContext, DepositorContext] = createRequiredContext<{
  depositor: IDepositor;
  escrowId: string;
  agreementType: AgreementFormEnum;
}>();

type Props = {
  depositorId: string;
  escrowId: string;
  agreementType: AgreementFormEnum;
};

const DepositorContextProvider = ({
  depositorId,
  escrowId,
  agreementType,
  children,
}: React.PropsWithChildren<Props>) => {
  const { data } = useFragment<IDepositor>({
    fragment: DepositorFields,
    fragmentName: 'DepositorFields',
    from: {
      __typename: 'Depositor',
      id: depositorId || '',
    },
  });

  const value = {
    depositor: data as IDepositor,
    escrowId,
    agreementType,
  };

  return <DepositorContext value={value}>{children}</DepositorContext>;
};

export { useDepositorContext, DepositorContextProvider };
